<template>
  <!--api分类-->
  <x-category></x-category>
</template>

<script>
export default {
  name: 'apiCate'
};
</script>

<style scoped>

</style>
